'use strict';

var blazy = require('blazy');


var loadImages = function() {
  new blazy({
    selector: 'img[data-src], div[data-src]',
    successClass: 'image-loaded',
    offset: 600,
  });
};

var init = function() {
  return Promise.resolve()
    .then(loadImages);
};

module.exports = {
  init: init,
};
